export enum Llm {
  openai = 'openai',
  azureopenai = 'azureopenai',
  geminiai = 'geminiai',
  claudeai = 'claudeai',
  others = 'others',
}

export enum Embedding {
  openai = 'openai',
  azureopenai = 'azureopenai',
  geminiai = 'geminiai',
  others = 'others',
}

export enum EntityType {
  dataSourceDef = 'dataSourceDef',
  dataSourceInstance = 'dataSourceInstance',
  agentDef = 'agentDef',
  agentInstance = 'agentInstance',
  userAppDef = 'userAppDef',
  userAppInstance = 'userAppInstance',
  pipelineBlueprint = 'pipelineBlueprint',
  pipelineInstance = 'pipelineInstance',
  conversation = 'conversation',
  userInteraction = 'userInteraction',
  setting = 'setting',
  settings = 'settings',
  user = 'user',
  entityUser = 'entityUser',
  entityUserInvite = 'entityUserInvite',
  dataSourceItem = 'dataSourceItem',
  dataSourceItemGroup = 'dataSourceItemGroup',
  automationService = 'automationService',
}
